<template>
  <div class="display-area">
    <header>
      <div class="logo"></div>
      <a class="headerBtn" href="#" @click="redirect">登出</a>
    </header>

    <div class="mainWrap">
      <h1>{{ show_local_name }}</h1>
      <div class="dateBox">
        <a href="#" @click="backQueryDate" class="leftBtn"><span class="leftArron"></span></a>
        <div class="pickDateBox">
          <div class="selectText"><label for="input_01">選擇日期</label></div>
          <div class="selectDate">
            <DatePick v-model="query_date"></DatePick>
          </div>
        </div>
        <a href="#" @click="forwardQueryDate" class="rightBtn"><span class="rightArron"></span></a>
      </div>
      <div class="dataWrap">
        <div class="dataWrapTop">
          <div class="dateLeft">
            <div class="dataTop1">當日使用次數</div>
            <div class="dataNumber"><span>{{ totalnum_of_date }}</span> 次</div>
          </div>
          <div class="dateRight">
          <div class="dataTop1">使用總次數</div>
            <div class="dataNumber"><span>{{ totalnum_of_show }}</span> 次</div>
          </div>
        </div>

        <ul class="dateMenu">
        <li><a href="#" @click="btnVisitActive" v-bind:class="{active: isVisitActive}">使用明細</a></li>
        <li><a href="#" @click="btnIndustryActive" v-bind:class="{active: isIndustryActive}">索取資訊</a></li>
        </ul>
        <div v-if="isVisitActive" class="dataBox">
          <div>
          <div class="sdataSec" v-for="(item, index) in details" :key="index">
            <div class="dataSecItem">
              <!--<div class="label">{{index+1}}</div> -->
              <div class="label">{{item.CREATE_DATE}}</div>
              <div class="label2">{{item.USER_NAME}}</div>
              <div class="label3">{{item.COMPANY_NAME}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isIndustryActive" class="dataBox">
          <div v-if="roleExh">
            <div class="sdataSec" v-for="(item, index) in IndustryDetails" :key="index">
              <div class="dataSecItem">
                <div class="label">{{index+1}}</div>
<!--                <div class="label">{{item.EXHIBITION_AREA}}</div>-->
                <div class="label2">{{item.COMPANY_INDUSTRY}}</div>
                <div class="label3">{{item.QTY}}</div>
              </div>
            </div>
          </div>
          <div v-if="roleOrg">
          <div class="sdataSec" v-for="(item, index) in IndustryDetails" :key="index">
            <div class="dataSecItem">
            <!--<div class="label">{{index+1}}</div>-->
            <div class="label">{{item.EXHIBITION_AREA}}</div>
            <div class="label2">{{item.COMPANY_NAME_LOCAL}}</div>
              <div class="label3">{{item.QTY}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="reavtion"><a href="#" @click="queryShowData">重整資料</a></div>
      </div>
    </div>

    <div id="container"></div>

  </div>
</template>

<style scoped src="../../public/css/firm.reset.css" />
<style scoped src="../../public/css/firm.default.css" />
<style scoped src="../../public/css/firm.default.date.css" />
<style scoped src="../../public/css/firm.system.css" />

<script>
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
import moment from "moment";

export default {
  name: "ShowInformation",
  components: {
    DatePick,
  },
  data: function () {
    return {
      showId: "",
      boothId: "",
      start_date: "",
      end_date: "",
      show_local_name: "",
      totalnum_of_show: 0,
      totalnum_of_date: 0,
      query_date: "",
      token: "",
      role: "",
      details: [],
      IndustryDetails:[],
      qryType: "",
      isVisitActive: true,
      isIndustryActive: false,
      logoutUrl: "",
      roleExh: false,
      roleOrg: false,
    };
  },
  created() {
    let today = new Date();
    this.query_date = moment(today).format('YYYY-MM-DD');
    this.showId = this.$route.params.showId;
    this.boothId = this.$route.params.boothId;
    this.token = this.$route.params.token;
    this.start_date = this.$route.params.start_date;
    this.end_date = this.$route.params.end_date;
    this.show_local_name = this.$route.params.show_local_name;
    this.role = this.$route.params.role;

    this.start_date = "",
    this.end_date = "",
    this.totalnum_of_show  = 0,
    this.totalnum_of_date = 0;

    if (this.role === 'Exhibitors') {
      this.roleExh = true;
    } else if (this.role === 'Organizer') {
      this.roleOrg = true;
    }
    this.logoutUrl  = ".FirmLogin/" + this.$route.params.showId;
    //this.queryShowData();
  },
  mounted() {
    document.querySelector('.vdpComponent.vdpWithInput input').setAttribute("style","font-size: 20px; font-weight: bold; color: #ffffff; background: none; border: none; text-align: center; padding: 0;");
    document.querySelector('.vdpClearInput').remove();
  },
  methods: {
    // 前一天
    forwardQueryDate: function() {
      let date = new Date(this.query_date);
      date.setDate(date.getDate() + 1 );
      let query_date_str = moment(date).format('YYYY-MM-DD');
      this.query_date = query_date_str;
      //this.queryShowData();
    },
    // 後一天
    backQueryDate: function() {
      let date = new Date(this.query_date);
      date.setDate(date.getDate() - 1 );
      let query_date_str = moment(date).format('YYYY-MM-DD');
      this.query_date = query_date_str;
      //this.queryShowData();
    },
    btnVisitActive: function() {
      this.isVisitActive = true;
      this.isIndustryActive = false;
      this.qryType = "Visit";
      this.queryShowData();
    },
    btnIndustryActive: function() {
      this.isVisitActive = false;
      this.isIndustryActive = true;
      this.qryType = "Industry";
      this.queryShowData();
    },
    queryShowData: function() {
      const data = { SHOW_ID: this.showId, BOOTH_ID: this.boothId, QUERY_DATE: this.query_date, ROLE: this.role, TOKEN: this.token };

      this.$ShowInfoAPI
        .QueryShowInfo(data)
        .then((res) => {
          const resultStr = res.data;
          // console.log(resultStr);
          const resultObj = JSON.parse(resultStr);
          if (resultObj.message === "Success") {
            this.totalnum_of_show = resultObj.body.TOTALNUM_OF_SHOW;
            this.totalnum_of_date = resultObj.body.TOTALNUM_OF_DATE;
            this.details = resultObj.body.DETAILS;
            if (this.qryType === 'Industry') {
              if (this.role === 'Exhibitors') {
                this.generateExhShowData(this.details);
              } else if (this.role === 'Organizer') {
              this.generateShowData(this.details);
            }
              // this.generateShowData(this.details);
            }
          } else {
            this.$alert.warningAlert(resultObj.message);
          }
        })
        .catch((error) => {
          this.$alert.warningAlert(error);
          console.error(error);
        });
    },
    generateShowData: function(details) {
      let result = [];
      details.reduce(function(res, value) {
        if (!res[value.COMPANY_NAME_LOCAL]) {
          res[value.COMPANY_NAME_LOCAL] = {EXHIBITION_AREA: value.EXHIBITION_AREA, COMPANY_NAME_LOCAL: value.COMPANY_NAME_LOCAL, QTY: 0};
          result.push(res[value.COMPANY_NAME_LOCAL])
        }
        res[value.COMPANY_NAME_LOCAL].QTY +=1;

        // if (!res[value.COMPANY_INDUSTRY]) {
        //   res[value.COMPANY_INDUSTRY] = {COMPANY_INDUSTRY: value.COMPANY_INDUSTRY, COMPANY_NAME: value.COMPANY_NAME, QTY: 0};
        //   result.push(res[value.COMPANY_INDUSTRY])
        // }
        // res[value.COMPANY_INDUSTRY].QTY +=1;
        return res;
      }, {});
      // console.log(result);
      this.IndustryDetails = result;
    },
    generateExhShowData: function(details) {
      let result = [];
      details.reduce(function(res, value) {
        if (!res[value.COMPANY_INDUSTRY]) {
          res[value.COMPANY_INDUSTRY] = {COMPANY_INDUSTRY: value.COMPANY_INDUSTRY, QTY: 0};
          result.push(res[value.COMPANY_INDUSTRY])
        }
        res[value.COMPANY_INDUSTRY].QTY +=1;

        // if (!res[value.COMPANY_INDUSTRY]) {
        //   res[value.COMPANY_INDUSTRY] = {COMPANY_INDUSTRY: value.COMPANY_INDUSTRY, COMPANY_NAME: value.COMPANY_NAME, QTY: 0};
        //   result.push(res[value.COMPANY_INDUSTRY])
        // }
        // res[value.COMPANY_INDUSTRY].QTY +=1;
        return res;
      }, {});
      //console.log(result);
      this.IndustryDetails = result;
    },
    redirect: function () {
      this.$router.push({
        name: "FirmLogin",
        path: {
          showId: this.SHOW_ID,
        },
      });
    },
  },
  watch: {
    query_date: function() {
      this.queryShowData();
    },
  },
};

</script>

<style scoped></style>
